import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'program-detail-eligibility-type';
function EligibilityItem(_ref) {
  let {
    visibility,
    title,
    options
  } = _ref;
  if (!visibility) return null;
  return /*#__PURE__*/_jsxs("li", {
    className: "".concat(DISPLAY_NAME, "-list-item leading-5"),
    children: [/*#__PURE__*/_jsx("span", {
      className: "font-medium-font",
      children: "".concat(title, ": ")
    }), /*#__PURE__*/_jsx("span", {
      children: options
    })]
  }, title);
}
EligibilityItem.propTypes = {
  visibility: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  options: PropTypes.string.isRequired
};
EligibilityItem.defaultProps = {};
export default EligibilityItem;
//# sourceMappingURL=EligibilityItem.js.map